/* Giesse Vintage — comparsa in scorrimento per le sezioni personalizzate.
   Ricalca tempi e distanze del sistema nativo di Dawn, così l'effetto
   è indistinguibile da quello delle sezioni originali del tema. */
(function () {
  if (window.__gsReveal) return;
  window.__gsReveal = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches) return;

  var style = document.createElement('style');
  style.textContent =
    '.gs-reveal{opacity:0;transform:translateY(1.6rem);will-change:opacity,transform}' +
    '.gs-reveal--in{animation:gsReveal .65s cubic-bezier(.16,1,.3,1) forwards}' +
    '@keyframes gsReveal{to{opacity:1;transform:translateY(0)}}';
  document.head.appendChild(style);

  /* Gli elementi che vale la pena far entrare uno dopo l'altro.
     Volutamente pochi: titoli, testi, pulsanti e le celle delle griglie. */
  var TARGETS = [
    '.gs-tag',
    '.gs-title',
    '.gs-lede',
    '.gs-hero__actions',
    '.gs-hero__video',
    '.gs-b2b-hero__actions',
    '.gs-sell-hero__actions',
    '.gs-fact',
    '.gs-step',
    '.gs-way',
    '.gs-pay',
    '.gs-criteria__col',
    '.gs-contact__aside',
    '.gs-form',
    '.gs-notice__row',
    '.gs-b2b-teaser__grid > *'
  ].join(',');

  var observer = null;

  function makeObserver() {
    if (!('IntersectionObserver' in window)) return null;
    return new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('gs-reveal--in');
          obs.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
  }

  function prepare(root) {
    var scopes = (root || document).querySelectorAll('.gs, .gs-notice');

    scopes.forEach(function (scope) {
      var items = scope.querySelectorAll(TARGETS);
      if (!items.length) return;

      items.forEach(function (el, i) {
        if (el.classList.contains('gs-reveal')) return;
        el.classList.add('gs-reveal');
        /* stesso passo di Dawn: 75ms, ma con un tetto così una griglia
           lunga non fa aspettare troppo l'ultimo elemento */
        el.style.animationDelay = Math.min(i, 6) * 75 + 'ms';

        if (observer) {
          observer.observe(el);
        } else {
          el.classList.add('gs-reveal--in');
        }
      });
    });
  }

  function start() {
    observer = makeObserver();
    prepare(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Nel personalizzatore le sezioni si ricaricano: rianima quella nuova */
  document.addEventListener('shopify:section:load', function (e) {
    prepare(e.target);
  });

  /* Se l'utente attiva "riduci animazioni" a pagina aperta, si smette */
  if (reduce.addEventListener) {
    reduce.addEventListener('change', function (e) {
      if (!e.matches) return;
      document.querySelectorAll('.gs-reveal').forEach(function (el) {
        el.classList.remove('gs-reveal');
        el.style.animationDelay = '';
      });
    });
  }
})();
